import compareClub from './compareClubAuth.component';
import stCompareClubButton from './compareClubButton.component';
import stCompareClubForm from './compareClubForm.component';

export default angular
  .module('st.Integrations.CompareClub', ['st.Core', 'angular-cache'])
  .component('compareClub', compareClub)
  .component('stCompareClubButton', stCompareClubButton)
  .component('stCompareClubForm', stCompareClubForm)
  .service('compareClubService', ($http, dataService, COMPARE_CLUB) => ({
    send: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        COMPARE_CLUB.API.SEND,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('COMPARE_CLUB', {
    API: {
      SEND: '/api/v1/integration/compareClub/refer'
    },
    QUESTIONS: {
      YES_NO: [
        { id: 0, value: 'Yes' },
        { id: 1, value: 'No' }
      ],
      GENDER: [
        { id: 'male', value: 'Male' },
        { id: 'female', value: 'Female' }
      ],
      QUOTE_TYPE: [
        { id: '', value: 'Select one' },
        { id: 'Life Insurance', value: 'Life Insurance' },
        { id: 'Health Insurance', value: 'Health Insurance' }
      ],
      HEALTH_FUND: [
        { id: '', value: 'Select one' },
        { id: 'Hospital', value: 'Hospital' },
        { id: 'Extras', value: 'Extras' },
        { id: 'Combined', value: 'Combined' }
      ],
      COVER_TYPE: [
        { id: '', value: 'Select one' },
        { id: 'Not Insured', value: 'Not Insured' },
        { id: 'ahm', value: 'AHM' },
        { id: 'AU', value: 'AU' },
        { id: 'Bupa', value: 'Bupa' },
        { id: 'Credicare', value: 'Credicare' },
        { id: 'GMF', value: 'GMF' },
        { id: 'GMHBA', value: 'GMHBA' },
        { id: 'HBA', value: 'HBA' },
        { id: 'HCF', value: 'HCF' },
        { id: 'Health Partners', value: 'Health Partners' },
        { id: 'HIF', value: 'HIF' },
        { id: 'La Trobe', value: 'La Trobe' },
        { id: 'MBF', value: 'MBF' },
        { id: 'Medibank', value: 'Medibank' },
        { id: 'Mutual Health', value: 'Mutual Health' },
        { id: 'MU', value: 'MU' },
        { id: 'Mutual Communities', value: 'Mutual Communities' },
        { id: 'Nib', value: 'Nib' },
        { id: 'Peoplecare', value: 'Peoplecare' },
        { id: 'RT', value: 'RT' },
        { id: 'RTA', value: 'RTA' },
        { id: 'SGIO', value: 'SGIO' },
        { id: 'St Lukes', value: 'St Lukes' },
        { id: 'Teachers', value: 'Teachers' },
        { id: 'Westfund', value: 'Westfund' },
        { id: 'Other', value: 'Other' },
        { id: 'Not_Sure', value: 'Not Sure' }
      ],
      LIFE_STAGE: [
        { id: '', value: 'Select one' },
        { id: 'Single', value: 'Single' },
        { id: 'Couple', value: 'Couple' },
        { id: 'Family', value: 'Family' },
        { id: 'Single Parent', value: 'Single Parent' }
      ]
    }
  });
